const PersianText = ({ children }) => {
    const toPersianDigits = (text = "") => {
      return text
      .toString()
      .replace(/,/g, "") // حذف کاماها
      .replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]); // جایگزینی اعداد انگلیسی با فارسی
      };
  
    return toPersianDigits(children)
  }
  export default PersianText